import _ from "underscore";
import PropTypes from "prop-types";

import React from "react";
import classNames from "classnames";
import BasicUtils from "../../utils/basic-utils";
import IconClass from "../elements/icon";

const Icon = React.createFactory(IconClass);
export default class extends React.Component {
  static displayName = "ToastAlert";

  static propTypes = {
    type: PropTypes.string,
    timeout: PropTypes.number,
    actionLabel: PropTypes.string,
    willBeRemoved: PropTypes.bool,
    icon: PropTypes.string,
    header: PropTypes.string,
    onAction: PropTypes.func,
    onClose: PropTypes.func,
    onUndo: PropTypes.func,
  };

  state = { animation: "in" };

  componentDidMount() {
    if (this.props.timeout) {
      _.delay(() => this.handleClose(), this.props.timeout);
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.willBeRemoved) {
      this.setState({ animation: "out" });
    }
  }

  handleClose = () => {
    if (_.isFunction(this.props.onClose)) {
      this.props.onClose();
    }
  };

  handleUndo = () => {
    if (_.isFunction(this.props.onUndo)) {
      this.props.onUndo();
      this.handleClose();
    }
  };

  handleAction = () => {
    if (_.isFunction(this.props.onAction)) {
      this.props.onAction();
      this.handleClose();
    }
  };

  renderChildren = () => {
    return _.map(BasicUtils.makeArray(this.props.children), (child, index) => {
      if (child.type) {
        return React.cloneElement(child, {
          key: index,
          onToastClose: this.handleClose,
        });
      } else {
        return child;
      }
    });
  };

  render() {
    const toastClasses = classNames(this.props.className, {
      "et--toast": true,
      "et--toast--success": this.props.type === "success",
      "et--toast--warning": this.props.type === "warning",
      "et--toast--error": this.props.type === "error",
      animated: true,
      fadeInRight: this.state.animation === "in",
      fadeOutUp: this.state.animation === "out",
    });

    const toastIcons = classNames(this.props.icon, {
      "et--toast--icon": true,
      "gt-icon": true,
      "gt-icon-access-time": !this.props.icon && this.props.type === "info",
      "gt-icon-check-circle": !this.props.icon && this.props.type === "success",
      "gt-icon-cancel": !this.props.icon && this.props.type === "warning",
      "gt-icon-alert-circle": !this.props.icon && this.props.type === "error",
    });

    return (
      <div className={toastClasses}>
        <i className={toastIcons} />
        {this.props.header ? (
          <div className="et--toast--message">
            <div className="et--toast--header">{this.props.header}</div>
            <div className="et--toast--body">{this.renderChildren()}</div>
          </div>
        ) : (
          <div className="et--toast--message">{this.renderChildren()}</div>
        )}
        {(this.props.onAction || this.props.onUndo) &&
          <div className="et--toast--actions">
            {this.props.onAction &&
              <a href="#" onClick={this.handleAction}>
                {this.props.actionLabel}
              </a>
            }
            {this.props.onUndo &&
              <a href="#" onClick={this.handleUndo}>
                Undo
              </a>
            }
          </div>
        }
        {Icon({
          className: "et--toast--close",
          icon: "close",
          onClick: this.handleClose,
        })}
      </div>
    );
  }
}
